module.exports = __webpack_public_path__ + "static/nine_noir_lives-c442fd5168c4e50f940abea95d97fc21.webp";